export default __webpack_public_path__ + "static/media/autobiography.dae28343.jpg";